import React from 'react'
import PropTypes from 'prop-types'

import StaticLogo from './StaticLogo'
import NextSlide from './NextSlide'
import PrevSlide from './PrevSlide'
import ProgressBar from './ProgressBar'

import './FixedGUI.scss'

const FixedGUI = ({ logo, scene, scenesNumber, onPrevSlide, onNextSlide }) => {
  return (
    <div>
      <StaticLogo logo={logo} visible={scene === 2 || scene === 8} scene={scene} />

      <PrevSlide onClick={onPrevSlide} visible={scene > 3} />
      <NextSlide onClick={onNextSlide} visible={scene > 3 && scene < scenesNumber - 1} />

      <ProgressBar progress={(scene - 2) / (scenesNumber - 3)} visible={scene > 2} />
    </div>
  )
}

FixedGUI.propTypes = {
  logo: PropTypes.string,
  scene: PropTypes.number,
  scenesNumber: PropTypes.number,
  onPrevSlide: PropTypes.func,
  onNextSlide: PropTypes.func
}

export default FixedGUI



// WEBPACK FOOTER //
// ./src/templates/app-website/components/fixed/FixedGUI.js